// frontend/src/components/Auth/LoginForm.js
//
// Thin modal that hosts Clerk's prebuilt <SignIn/> and <SignUp/> components.
// Clerk handles password, email confirmation, and password reset flows — we
// no longer need to build any of that ourselves.

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { SignIn, SignUp } from '@clerk/clerk-react';
import { X } from 'lucide-react';

const LoginForm = ({ onClose, initialMode = 'signin', redirectUrl = '/' }) => {
  const [isSignUp, setIsSignUp] = useState(initialMode === 'signup');
  const [modalRoot, setModalRoot] = useState(null);

  useEffect(() => {
    let root = document.getElementById('modal-root');
    if (!root) {
      root = document.createElement('div');
      root.id = 'modal-root';
      document.body.appendChild(root);
    }
    setModalRoot(root);

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  const modalContent = (
    <div
      onClick={handleBackdropClick}
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        zIndex: 999999,
        backdropFilter: 'blur(4px)',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'relative',
          maxHeight: '90vh',
          overflowY: 'auto',
        }}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            position: 'absolute',
            top: '0.5rem',
            right: '0.5rem',
            zIndex: 10,
            background: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '9999px',
            width: '2rem',
            height: '2rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            color: '#6b7280',
          }}
        >
          <X size={16} />
        </button>

        {isSignUp ? (
          <SignUp
            routing="virtual"
            signInUrl="#"
            fallbackRedirectUrl={redirectUrl}
          />
        ) : (
          <SignIn
            routing="virtual"
            signUpUrl="#"
            fallbackRedirectUrl={redirectUrl}
          />
        )}

        <div style={{ textAlign: 'center', marginTop: '0.75rem' }}>
          <button
            onClick={() => setIsSignUp((s) => !s)}
            style={{
              color: '#10b981',
              background: 'none',
              border: 'none',
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            {isSignUp
              ? 'Already have an account? Sign in'
              : "Don't have an account? Sign up"}
          </button>
        </div>
      </div>
    </div>
  );

  return modalRoot ? ReactDOM.createPortal(modalContent, modalRoot) : null;
};

export default LoginForm;
